import gql from 'graphql-tag';

const GET_NOTIFICATION_TEMPLATE_ACTIVATED_STATUS = gql`
  query getNotificationTemplateActivatedStatus($input: String!) {
    getNotificationTemplateActivatedStatus(input: $input)
  }
`;

export { GET_NOTIFICATION_TEMPLATE_ACTIVATED_STATUS };
